import DurationSlider from './DurationSlider';

export default DurationSlider;
